// mantine
import { Avatar, Checkbox } from '@mantine/core';
// utils
import { IConversationsIntegration } from '@newo/api/gateway';
import { getIntegrationLogo } from '@/modules/Integrations/Integrations.utils.ts';
// assets
import styles from '@/modules/Integrations/components/ConnectorSelect/components/Integration/Integration.module.css';

interface IntegrationProps {
    integration: IConversationsIntegration;
    values: string[];
    onChange: (value: string[]) => void;
}

const Integration = ({ integration, values, onChange }: IntegrationProps) => {
    const {
        integration: { idn, title },
        connectors
    } = integration;

    const pairs = connectors.map((connector) => `${idn}/${connector.idn}`);

    const handleIntegrationChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (event.currentTarget.checked) {
            onChange([...values, ...pairs]);
            return;
        }
        onChange(values.filter((value) => !pairs.includes(value)));
    };

    const isAllChecked = pairs.every((c) => values.includes(c));

    return (
        <div className={styles.wrapper}>
            <Checkbox
                checked={isAllChecked}
                className={styles.checkbox}
                disabled={pairs.length === 0}
                label={
                    <div className="flex items-center gap-1">
                        <Avatar
                            alt={title}
                            className="bg-gray-2"
                            radius="xl"
                            size="xs"
                            src={getIntegrationLogo(idn)}
                        >
                            {idn.at(0)}
                        </Avatar>
                        {title}
                    </div>
                }
                onChange={handleIntegrationChange}
            />

            <div className={styles.connectors}>
                {connectors.map((connector) => {
                    const value = `${idn}/${connector.idn}`;

                    const handleConnectorChange = (
                        event: React.ChangeEvent<HTMLInputElement>
                    ) => {
                        if (event.currentTarget.checked) {
                            onChange([...values, value]);
                            return;
                        }
                        onChange(values.filter((v) => value !== v));
                    };

                    return (
                        <Checkbox
                            checked={values.includes(value)}
                            className={styles.checkbox}
                            key={connector.idn}
                            label={connector.title}
                            onChange={handleConnectorChange}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default Integration;
